module.exports = __webpack_public_path__ + "img/arena-top100.com.a669189c.png";